export const DOCUMENTATION_CARD = {
    TITLE: 'Documentation',
    DESCRIPTION:
        'Access our developer documents for step-by-step guides and detailed instructions to get the most out of your LifeGraph.',
    ACTION: 'OPEN DOCS',
};
